<div>
  <mat-toolbar class="mat-elevation-z1 wrap-content">
    <mat-toolbar-row class="dash-toolbar">
      <div class="flex flex-row flex-wrap flex-[1_1_100%]">
        <div class="flex flex-col flex-auto justify-center items-start mat-subtitle-2">
          <div class="flex flex-row gap-5 flex-[1_1_100%] justify-center items-center sm:hidden">
            {{getSelectedValues()}}
          </div>
          <div class="sm:flex flex-row gap-5 flex-[1_1_100%] justify-center items-center hidden" [formGroup]="f" id="toolbarOverviewForm">
            @if (_clientsSelector && client) {
              <mat-form-field class="fill-content-selector" appearance="fill">
                <mat-select [formControl]="client" [attr.disabled]="_activeProgress">
                  <mat-option value="null">
                    {{'ALL_CLIENTS' | translate}}
                  </mat-option>
                  @for (client of _clientList; track client) {
                    <mat-option [value]="client.uid">
                      @if (parent(client) && selectedClient(client)) {
                        <mat-icon>supervisor_account</mat-icon>
                        } &nbsp;{{client.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (_storeSelector) {
                <mat-form-field class="fill-content-selector" appearance="fill">
                  <mat-select data-intercom-target="dashboard-store-dropdown" [formControl]="store" [attr.disabled]="_activeProgress">
                    <mat-option value="null">
                      {{'ALL_STORES' | translate}}
                    </mat-option>
                    @for (store of _storeList; track store) {
                      <mat-option [value]="store.uid">{{store.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <mat-form-field class="date-range-input flex-auto" appearance="fill" data-intercom-target="dashboard-date-range-field">
                <mat-label>{{'DATE_RANGE' | translate}}</mat-label>
                <input matInput [max]="maxDate" [shopboxDatepicker]="resultPicker" [ngClass]="{'unClickable': _activeProgress }" (click)="resultPicker.open()" [formControl]="datePicker" readonly>
                <shopbox-datepicker-toggle matSuffix [for]="resultPicker" class="toggle-datepicker"  [attr.disabled]="_activeProgress" [ngClass]="{'unClickable': _activeProgress }" data-pdf-ignore="true"></shopbox-datepicker-toggle>
                <shopbox-datepicker
                  [touchUi]="touch"
                  #resultPicker
                  [rangeMode]="true"
                  [showCalendarButtons]="true"
                  [lastYearLabel]="'LAST_YEAR' | translate"
                  [lastWeekLabel]="'LAST_WEEK' | translate"
                  [thisYearLabel]="'THIS_YEAR' | translate"
                  [thisWeekLabel]="'THIS_WEEK' | translate"
                  [thisMonthLabel]="'THIS_MONTH' | translate"
                  [lastMonthLabel]="'LAST_MONTH' | translate"
                  [yesterdayLabel]="'YESTERDAY' | translate"
                  [cancelLabel]="'CLEAR_SELECTION' | translate"
                  [todayLabel]="'TODAY' | translate">
                </shopbox-datepicker>
              </mat-form-field>
              @if (compareRevenue) {
                <div class="fill-content-selector">
                  @if (compareRevenueText.trim()) {
                    <b class="compare-text off">
                      {{compareRevenueText}}
                    </b>
                  }
                </div>
              }
              @if (staffMembersSelector) {
                <mat-form-field class="fill-content-selector" appearance="fill">
                  <mat-select data-intercom-target="dashboard-staff-members-dropdown" [formControl]="staffMembers" [attr.disabled]="_activeProgress">
                    <mat-option value="1">
                      {{'ALL_STAFF_MEMBERS' | translate}}
                    </mat-option>
                    <mat-option value="2">
                      {{'COMPARE_BY_STAFF_MEMBER' | translate}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              }
            </div>
          </div>
          <div class="flex flex-col flex-auto justify-center items-end" data-pdf-ignore="true">
            <div class="flex flex-row gap-2.5 justify-center items-center">
              @if (vatNumbers) {
                <mat-slide-toggle data-intercom-target="dashboard-include-vat-toggle" color="primary" class="include-vat" [checked]="vatOn" (toggleChange)="setVatOnValue()" [labelPosition]="'before'">{{'INCLUDE_VAT' | translate}}</mat-slide-toggle>
              }
              @if (downloadButton) {
                <button type="button" mat-icon-button data-intercom-target="dashboard-download-button" matTooltip="{{'DOWNLOAD' | translate}}" (click)="donwloadClick()" [disabled]="_activeProgress" id="download-btn" class="hidden sm:block">
                  <mat-icon color="primary" class="publish">publish</mat-icon>
                </button>
              }
              @if (updateButton) {
                <button type="button" mat-icon-button data-intercom-target="dashboard-refresh-button" matTooltip="{{'ACTIONS.REFRESH' | translate}}" (click)="updateData()" [disabled]="_activeProgress" id="refresh-btn">
                  <mat-icon>refresh</mat-icon>
                </button>
              }
              @if (filterControls) {
                <button type="button" mat-icon-button matTooltip="{{'FILTER' | translate}}" (click)="toggleOptionControl()" [disabled]="_activeProgress" id="filter-btn" class="block sm:!hidden">
                  <mat-icon>filter_list</mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    @if (optionControl) {
      <div class="options-panel mat-subtitle-2 block sm:hidden" data-pdf-ignore="true">
        <div class="flex flex-col gap-5" [formGroup]="f">
          @if (_clientsSelector && client) {
            <mat-form-field class="flex-[1_1_100%]" appearance="fill">
              <mat-select [formControl]="client" [attr.disabled]="_activeProgress">
                <mat-option value="null">
                  {{'ALL_CLIENTS' | translate}}
                </mat-option>
                @for (client of _clientList; track client) {
                  <mat-option [value]="client.uid">
                    @if (parent(client) && selectedClient(client)) {
                      <mat-icon>supervisor_account</mat-icon>
                      } &nbsp;{{client.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (_storeSelector) {
              <mat-form-field class="flex-[1_1_100%]" appearance="fill">
                <mat-select [formControl]="store" [attr.disabled]="_activeProgress">
                  <mat-option value="null">
                    {{'ALL_STORES' | translate}}
                  </mat-option>
                  @for (store of _storeList; track store) {
                    <mat-option [value]="store.uid">{{store.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <mat-form-field class="w-full" appearance="fill">
              <mat-label>{{'DATE_RANGE' | translate}}</mat-label>
              <input matInput [max]="maxDate" [shopboxDatepicker]="resultPicker" [ngClass]="{'unClickable': _activeProgress }" (click)="resultPicker.open()" [formControl]="datePicker" readonly>
              <shopbox-datepicker-toggle matSuffix [for]="resultPicker" class="toggle-datepicker"  [attr.disabled]="_activeProgress" [ngClass]="{'unClickable': _activeProgress }"></shopbox-datepicker-toggle>
              <shopbox-datepicker
                [touchUi]="touch"
                #resultPicker
                [rangeMode]="true"
                [showCalendarButtons]="true"
                [lastYearLabel]="'LAST_YEAR' | translate"
                [lastWeekLabel]="'LAST_WEEK' | translate"
                [thisYearLabel]="'THIS_YEAR' | translate"
                [thisWeekLabel]="'THIS_WEEK' | translate"
                [thisMonthLabel]="'THIS_MONTH' | translate"
                [lastMonthLabel]="'LAST_MONTH' | translate"
                [yesterdayLabel]="'YESTERDAY' | translate"
                [cancelLabel]="'CLEAR_SELECTION' | translate"
                [todayLabel]="'TODAY' | translate">
              </shopbox-datepicker>
            </mat-form-field>
            @if (compareRevenue) {
              <div class="fill-content-selector">
                @if (compareRevenueText.trim()) {
                  <button mat-button [class.mat-raised-button]="compareRevenueOn" [class.off]="!compareRevenueOn" (click)="setCompareOnValue()" class="compare-text">{{compareRevenueText}}</button>
                }
              </div>
            }
            @if (staffMembersSelector) {
              <mat-form-field appearance="fill">
                <mat-select [formControl]="staffMembers" [attr.disabled]="_activeProgress">
                  <mat-option value="1">
                    {{'ALL_STAFF_MEMBERS' | translate}}
                  </mat-option>
                  <mat-option value="2">
                    {{'COMPARE_BY_STAFF_MEMBER' | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            }
            <div class="flex-[1_1_100%] flex justify-end">
              <button mat-raised-button color="primary" (click)="filter();" [disabled]="_activeProgress">{{"FILTER" | translate}}</button>
            </div>
          </div>
        </div>
      }
    </div>
